module.exports = __webpack_public_path__ + "static/media/ic_age_limit.c56a695c.png";